import { isEmpty } from 'lodash';
import { FileUploader, FileUploaderOptions, FileLikeObject } from 'ng2-file-upload';
import { StringUtility } from './string-utility';

export class CustomFileUploader extends FileUploader {
  constructor(options: FileUploaderOptions) {
    super(options);
  }

  public addToQueue(files: File[], _options?: FileUploaderOptions, filters?: [] | string): void {
    for (const file of files) {
      if (!!_options && !isEmpty(_options)) {
        if (!!_options.maxFileSize && file.size > _options.maxFileSize) {
          const fileLikeObject: FileLikeObject = new FileLikeObject(file);
          this.onWhenAddingFileFailed(fileLikeObject, { name: 'fileSize' }, _options);
          continue;
        }

        if (!!_options.allowedMimeType && !!_options.allowedMimeType.length) {
          if (!this.isMimeTypeAllowed(file.type, _options.allowedMimeType)) {
            const fileLikeObject: FileLikeObject = new FileLikeObject(file);
            this.onWhenAddingFileFailed(fileLikeObject, { name: 'mimeType' }, _options);
            continue;
          }
        }
      }
      super.addToQueue([file], _options, filters);
    }
  }

  private isMimeTypeAllowed(fileMimeType: string, allowedMimeTypes: string[]): boolean {
    return StringUtility.hasAnyMatchInArray(allowedMimeTypes, [fileMimeType]);
  }
}
